export default "__VITE_ASSET__CZoFEBRw__"